"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var util_1 = require("../util");

var State_1 = require("../State");

var renderProp_1 = tslib_1.__importDefault(require("../util/renderProp"));

var faccToHoc_1 = tslib_1.__importDefault(require("../util/faccToHoc"));

exports.Value = function (props) {
  return util_1.h(State_1.State, {
    init: {
      value: props.init
    },
    render: function render(_a, _set) {
      var value = _a.value;
      return renderProp_1.default(props, {
        value: value,
        set: function set(value) {
          return _set({
            value: value
          });
        }
      });
    }
  });
};

exports.faccToHocInit = function (Facc, name) {
  return function (Comp, name2, init) {
    var isClassDecoratorMethodCall = typeof Comp === 'string';

    if (isClassDecoratorMethodCall) {
      return faccToHoc_1.default(Facc, name)(Comp, {
        init: name2
      });
    } else {
      return faccToHoc_1.default(Facc, name)(Comp, name2, {
        init: init
      });
    }
  };
};

exports.withValue = exports.faccToHocInit(exports.Value, 'value');